import {
  PASSKEY_PROMPT_DISMISSED_KEY,
  PASSKEY_PROMPT_PENDING_KEY,
} from '@/constant/localStorage';
import storage from '@/utils/storage';

// sessionStorage can throw (Safari private mode, blocked storage); the prompt is optional.
const session = {
  get: (key: string) => {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set: (key: string, value: string) => {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      /* the prompt just won't show */
    }
  },
  remove: (key: string) => {
    try {
      sessionStorage.removeItem(key);
    } catch {
      /* nothing to clear */
    }
  },
};

/** Called by the sign-in form after a password sign-in in this tab. */
export const markPasswordSignIn = () =>
  session.set(PASSKEY_PROMPT_PENDING_KEY, '1');

export const isPasswordSignInPending = () =>
  session.get(PASSKEY_PROMPT_PENDING_KEY) === '1';

export const clearPasswordSignIn = () =>
  session.remove(PASSKEY_PROMPT_PENDING_KEY);

function dismissedIds(): number[] {
  try {
    const value = JSON.parse(
      storage.getItem(PASSKEY_PROMPT_DISMISSED_KEY) ?? '[]'
    );
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
}

/** Dismissal is per User, on this device. */
export const isPromptDismissed = (userId: number) =>
  dismissedIds().includes(userId);

export const dismissPrompt = (userId: number) => {
  const ids = dismissedIds();
  if (!ids.includes(userId)) {
    storage.setItem(
      PASSKEY_PROMPT_DISMISSED_KEY,
      JSON.stringify([...ids, userId])
    );
  }
};
